import React, { useState } from "react";
import { Theme } from "interfaces/theme";

import Banner from "./Banner";
import Eye from "./Eye";
import SwitchMode from "./SwitchMode";
import Gallery from "./Gallery";
import Footer from "./Footer";
import * as S from "./styles";

const Main: React.FC = () => {
  const [mode, setMode] = useState<Theme>("light");
  return (
    <S.Container mode={mode}>
      <SwitchMode onSwitch={setMode} mode={mode} />
      <S.Content>
        <Banner mode={mode} />
        <Eye mode={mode} />
        <Gallery mode={mode} />
        <Footer mode={mode} />
      </S.Content>
    </S.Container>
  );
};

export default Main;
